import { Button, Datepicker, Dropdown, TextInput } from 'flowbite-react'
import React, { useEffect, useState } from 'react'
import filterIcon from '../../../assets/filterIcon.png'
import { FaEllipsisH, FaPlusCircle, FaSearch } from 'react-icons/fa'
import downloadIcon from '../../../assets/document-download.png'
import PrivateLayout from '../../../layouts/PrivateLayout/PrivateLayout'
import CustomTable from '../../../components/Table/CustomTable'
import DashboardPagesTemplate from '../../../components/DashboardPagesTemplate/DashboardPagesTemplate'
import modalIcon from '../../../assets/shareholdersIcon.png'
import CreateInvoiceModalContent from './CreateInvoiceModalContent'
import client from '../../../api/client'
import { InvoiceData, ColumnInvoice } from '../../../types/TablesTypes/Invoice'
import showToast from '../../../components/CustomToast/toastHelper'
import moment from 'moment'
import { numberWithCommas } from '../../../utils/formatNumber'
import StatusView from '../../../components/StatusView/StatusView'

interface InvoiceFilters {
    toDate: string,
    fromDate: string,
    status: string,
    bearer: string
}
const Invoices = () => {
    const [filters, setFilters] = useState({
        toDate: "",
        fromDate: "",
        status: "",
    })

    const [invoices, setInvoices] = useState<any>()
    const [bearer, setBearer] = useState(false)
    const [tableRow, setTableRow] = useState<any[]>();

    const handleFilterChange = (filterName: string, value: string) => {
        setFilters({
            ...filters,
            [filterName]: value
        });
    }

    useEffect(() => {
        const fetchData = async () => {
            await fetchInvoices();
        };
        fetchData();
    }, [filters,bearer]);

    const fetchInvoices = async () => {
        try {
            const apiUrl = '/subsidiary/dashboard/invoice/all';
            const params = new URLSearchParams(filters).toString;
            const response = await client.get(`${apiUrl}`);

            setInvoices(response.data.data);
            const message = response?.data?.message;

        } catch (err: any) {
            if (err?.response?.data?.message === 'Please login again') {
                sessionStorage.clear();
                window.location.href = '/';
            } else {
                const message = err?.response?.data?.message;
                console.error('error getting data', err);
                showToast(message, "error");
            }
        }
    };

    const dataInvoices = () => {
        const tempArr: InvoiceData[] = [];
        invoices?.items
            ?.slice(0)
            .reverse()
            .forEach((invoice: any, index: number) => {
                tempArr.push({
                    title: invoice?.title,
                    reference: invoice?.reference,
                    amount: `${invoice?.currency} ${numberWithCommas(invoice?.amount)}`,
                    dueDate: moment(invoice?.dueDate).format("MMMM Do YYYY, h:mm a"),
                    status: (
                        <StatusView
                            status={invoice?.status}
                            green="Paid"
                            red="Unpaid"
                            orange="Pending"
                        />
                    ),
                    action: (
                        <Dropdown label={
                            <FaEllipsisH/>
                        } inline arrowIcon={false} placement='right-start'>
                            
                        </Dropdown>
                    ),
                });
            });
        return tempArr;
    };

    useEffect(() => {
        const fetch = async () => {
            setTableRow(dataInvoices());
        }
        fetch()
    }, [invoices?.items]);

    return (

        <DashboardPagesTemplate title='Invoices'
            onFilterChange={setFilters}
            apiUrl=''
            data={tableRow ? tableRow : []}
            children={<CreateInvoiceModalContent />} filters={filters}
            exportButtonExists={true}
            dropdownItems={["Successful", "Failed", "Pending"]} buttonLabel='New Invoice'
            buttonIcon={<FaPlusCircle />} headings={ColumnInvoice} showSearch={false}
            ctaButtonExists={true}
            emptyMessage='You do not have any invoices' />
            
    )
}

export default Invoices